import { render } from "./ChirpView.vue?vue&type=template&id=0f2f08da&ts=true"
import script from "./ChirpView.vue?vue&type=script&lang=ts"
export * from "./ChirpView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__